import React from "react";
import Lottie from "react-lottie";
import animationData from "../../assets/order_status_loading.json";

export default function Loading() {
  return (
    <div
      style={{ marginTop: 100 }}
      className="text-center d-flex justify-content-center align-items-center"
    >
      <div className="spinner-grow text-primary" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}

export function FoodLoading() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return <Lottie options={defaultOptions} height={300} width={300} />;
}
